/** Formatadores de exibição. Toda moeda passa por aqui. */
/**
 * Instanciado uma vez no módulo: `Intl.NumberFormat` é caro de construir e
 * seria recriado a cada render se ficasse dentro do componente.
 */
const FORMATO_MOEDA = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});
/** 245000 -> "R$ 2.450,00" */
export function formatarPreco(centavos) {
    return FORMATO_MOEDA.format(centavos / 100);
}
/**
 * Converte o que o usuário digitou em centavos.
 * Aceita "2450", "2.450,00", "2450,5", "R$ 2.450,00".
 * Devolve null quando não dá para interpretar.
 */
export function precoParaCentavos(entrada) {
    if (typeof entrada === 'number') {
        return Number.isFinite(entrada) ? Math.round(entrada * 100) : null;
    }
    const limpo = entrada.replace(/[^\d,.-]/g, '').trim();
    if (!limpo)
        return null;
    // pt-BR: "." é milhar e "," é decimal.
    const normalizado = limpo.replace(/\./g, '').replace(',', '.');
    const valor = Number(normalizado);
    if (!Number.isFinite(valor) || valor < 0)
        return null;
    return Math.round(valor * 100);
}
/** A API devolve `preco` como string "2450.00" (Decimal nunca vira number). */
export function precoStringParaCentavos(preco) {
    return Math.round(Number(preco) * 100);
}
/** "556239423988" -> "(62) 3942-3988"; "5562999998888" -> "(62) 99999-8888" */
export function formatarTelefone(digitos) {
    const so = digitos.replace(/\D/g, '');
    const semDdi = so.startsWith('55') && so.length >= 12 ? so.slice(2) : so;
    if (semDdi.length === 11) {
        return `(${semDdi.slice(0, 2)}) ${semDdi.slice(2, 7)}-${semDdi.slice(7)}`;
    }
    if (semDdi.length === 10) {
        return `(${semDdi.slice(0, 2)}) ${semDdi.slice(2, 6)}-${semDdi.slice(6)}`;
    }
    return digitos;
}
const FORMATO_DATA = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});
export function formatarData(valor) {
    if (!valor)
        return '';
    const data = typeof valor === 'string' ? new Date(valor) : valor;
    return Number.isNaN(data.getTime()) ? '' : FORMATO_DATA.format(data);
}
/** "3 fotos" / "1 foto" / "nenhuma foto" */
export function pluralizar(n, singular, plural, zero) {
    if (n === 0 && zero)
        return zero;
    return `${n} ${n === 1 ? singular : plural}`;
}
//# sourceMappingURL=formatar.js.map